export * from './sincronizador-equipamento-historico.componente';
export * from './controllers/comunicacao-coletor.controller';
export * from './controllers/comunicacao-nuvem.controller';
export * from './sincronizador-equipamento-historico.module';
